import { useTranslation } from 'react-i18next'

import EditWidgetForm from './EditWidgetForm'
import Widget from '../Widget'

export const useNON_COMPLIANCES_COUNTER_CONFIG = () => {
  const { t } = useTranslation('common')

  return {
    id: 'NON_COMPLIANCES_COUNTER',
    name: t('widgets.nonCompliancesCounter.name'),
    description: t('widgets.nonCompliancesCounter.description'),
    color: 'red',
    icon: 'RiTimerLine',
    categories: [t('widgets.nonCompliancesCounter.category')],
    previewWidth: '45%',

    initialState: {
      name: t('widgets.nonCompliancesCounter.initialStateName'),
      size: { width: 25, height: 175 },
      data: {}
    },

    Presentation: Widget,
    Form: EditWidgetForm
  }
}
